<template>
    <div class="header">
      <md-toolbar class="md-medium">
        <div class="md-toolbar-row d-flex justify-content-start align-items-center">
          <h3 class="title-header mr-4">ISEP</h3>
          <div class="phone-viewport">
            <md-bottom-bar md-sync-route>
              <md-bottom-bar-item to="/isep/proceso" md-label="Home">Nuevo Registro</md-bottom-bar-item>
              <md-bottom-bar-item to="/isep/alta" md-label="Posts">Alta Nueva</md-bottom-bar-item>
              <md-bottom-bar-item to="/isep/reportes" md-label="Posts">Reportes</md-bottom-bar-item>
              <md-bottom-bar-item to="/isep/consulta" md-label="Favorites">Consulta Pendientes</md-bottom-bar-item>
            </md-bottom-bar>
          </div>
          <md-menu md-size="medium" md-align-trigger>
            <md-button md-menu-trigger style="color: #f26c4f;"> 
              <img src="./user.png" class="mr-2">{{ user }}
            </md-button>
            <md-menu-content>
              <md-menu-item style="color: #f26c4f;" class="content-item" @click="logOutISep">
                <i class="fas fa-sign-out-alt"></i>Cerrar Sesion
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      </md-toolbar>
    </div>
  </template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        // logOutISep: Function,
    },
    data(){
        return{
        user: localStorage.getItem('userId'),
        token: localStorage.getItem('token'),
        }
    },
    methods:{
      ...mapActions({
            logOutISep: 'logOutISep'  // Si el módulo tiene un namespace
        }),
        logOutISep() {
            this.$store.dispatch('logOutISep');
        },
    },
    mounted(){
      this.token == null ? this.logOutISep() : this.token
      
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.md-toolbar-row {
  justify-content: flex-start;
}
.md-bottom-bar .md-bottom-bar-item {
    background-color: #1a315e !important;
    color: white !important;
    height: 80px;
    width: 150px;
    text-decoration: none;
    box-shadow: none !important;
    border: none !important;
}
.title-header{
    color: #9cc4e4 !important;
    font-weight: 700;
    font-size: 3rem;
    /* margin: .6rem */
}
.md-bottom-bar, 
.md-bottom-bar::before, 
.md-bottom-bar::after,
.md-bottom-bar-item::before,
.md-bottom-bar-item::after {
  box-shadow: none !important;
  border: none !important; /* También puede ser una sombra aplicada como borde */
}
.navbar-nav {
  margin-left: 10px;
}

.md-menu {
  margin-left: auto;
}
.nav-link{
    font-size: 15px;
    color: #aab6ce !important;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
}
.nav-link:active, 
.nav-link:focus, 
.nav-link:hover {
  text-decoration: none;
  color: #a3b2d1 !important;
  font-weight: 500;
}
img{
    height: 2rem !important;
}
.md-toolbar.md-theme-default {
    
    background-color: #1b325f;
}
.title-header{
    color: #9cc4e4;
    font-weight: 700;
    font-size: 3rem;
    margin: .6rem
}
</style>